// Add your custom JS here.
import Alpine from 'alpinejs';
import AOS from 'aos';
//import intersect from '@alpinejs/intersect'

// ========================================
// Initialize all components
// ========================================
document.addEventListener('DOMContentLoaded', function () {
    initVideoOverlays();
    initHeroParallax();
    initImageStackTopParallax();

    initScrollToAnyHashId({
        scrollOnLoad: true,
        delayMs: 350,
        onAfterScroll: (target, id) => {
            if (id === 'form_section') {
                checkDemoCheckbox({
                    container: target,
                    checkboxNames: ['DEMO', 'demo[]'],
                    triggerChangeEvent: true
                });
            }
        }
    });
});

// Start Alpine.js
//Alpine.plugin(intersect);
window.Alpine = Alpine;
Alpine.start();

// Start Aos.js
AOS.init({
    disable: 'mobile',
});

/**
 * Scrolla verso l'elemento puntato da QUALSIASI hash (#qualcosa) se l'ID esiste.
 * Include hook onAfterScroll(target, id) per eseguire azioni dopo lo scroll (es. spuntare checkbox).
 */
function initScrollToAnyHashId(options = {}) {
    const {
        scrollBehavior = 'smooth',
        scrollBlock = 'start',
        delayMs = 0,
        preventDefault = true,
        scrollOnLoad = false,
        onAfterScroll = null
    } = options;

    const decodeHash = (hash) => {
        const raw = (hash || '').replace(/^#/, '');
        if (!raw) return '';
        try {
            return decodeURIComponent(raw);
        } catch (_) {
            return raw;
        }
    };

    const scrollToIdIfExists = (id) => {
        if (!id) return null;

        const target = document.getElementById(id);
        if (!target) return null;

        target.scrollIntoView({ behavior: scrollBehavior, block: scrollBlock });
        return target;
    };

    const runAfterScroll = (target, id) => {
        if (typeof onAfterScroll !== 'function') return;

        if (delayMs > 0) {
            setTimeout(() => onAfterScroll(target, id), delayMs);
        } else {
            onAfterScroll(target, id);
        }
    };

    function handleClick(e) {
        const link = e.target.closest('a[href]');
        if (!link) return;

        const href = link.getAttribute('href') || '';
        const hashIndex = href.indexOf('#');
        if (hashIndex < 0) return;

        const hash = href.slice(hashIndex);
        const id = decodeHash(hash);
        if (!id) return;

        const target = scrollToIdIfExists(id);
        if (!target) return;

        if (preventDefault) {
            e.preventDefault();
            history.replaceState(null, '', `#${encodeURIComponent(id)}`);
        }

        runAfterScroll(target, id);
    }

    document.addEventListener('click', handleClick, false);

    if (scrollOnLoad) {
        const id = decodeHash(window.location.hash);
        if (id) {
            // piccolo timeout per lasciare stabilizzare il layout
            setTimeout(() => {
                const target = scrollToIdIfExists(id);
                if (target) runAfterScroll(target, id);
            }, 0);
        }
    }

    return function destroy() {
        document.removeEventListener('click', handleClick, false);
    };
}

/**
 * Spunta un checkbox DEMO accettando più varianti di name (es: "DEMO", "demo[]", ecc.)
 * Cerca dentro un form specifico (o dentro un container/target da cui risale al form).
 */
function checkDemoCheckbox(options = {}) {
    const {
        container = document,
        checkboxNames = ['DEMO', 'demo[]'],
        triggerChangeEvent = true
    } = options;

    const names = Array.isArray(checkboxNames) ? checkboxNames : [checkboxNames];

    const escapeCss = (value) => {
        if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(value);
        return String(value).replace(/["\\]/g, '\\$&');
    };

    const findForm = () => {
        if (!container) return null;
        if (container.tagName && container.tagName.toLowerCase() === 'form') return container;
        return container.closest?.('form') || container.querySelector?.('form') || null;
    };

    const form = findForm();
    if (!form) return false;

    for (const n of names) {
        const el = form.querySelector(`input[type="checkbox"][name="${escapeCss(n)}"]`);
        if (el) {
            el.checked = true;
            if (triggerChangeEvent) el.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
        }
    }

    const wanted = names.map((n) => String(n).toLowerCase());
    const all = form.querySelectorAll('input[type="checkbox"][name]');
    for (const el of all) {
        const nm = (el.getAttribute('name') || '').toLowerCase();
        if (wanted.includes(nm)) {
            el.checked = true;
            if (triggerChangeEvent) el.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
        }
    }

    return false;
}


// Start VideoOverlay
function initVideoOverlays(root) {
    // root opzionale: di default è document
    const context = root || document;

    const overlays = context.querySelectorAll('.js-video-overlay');

    overlays.forEach(function (overlay) {
        const wrapper = overlay.closest('.position-relative');
        if (!wrapper) return;

        const video = wrapper.querySelector('.js-video');
        if (!video) return;

        overlay.addEventListener('click', function () {
            // Mostro i controlli solo dopo il click
            if (!video.hasAttribute('controls')) {
                video.setAttribute('controls', 'controls');
            }

            video.play();
            overlay.classList.add('d-none'); // nasconde l’overlay per sempre
        });
    });
}

function initHeroParallax() {
    const hero = document.querySelector('.hero-cover');
    const stack = document.querySelector('.image-stack-hero');
    if (!hero || !stack) return;

    const prefersReduced =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    // Base (desktop)
    const BASE_MOVE_BACK = 80;
    const BASE_MOVE_MID = 100;

    // Riduzione mobile (0.0 - 1.0)
    const MOBILE_FACTOR = 0.20; // es. 45% dei movimenti

    const clamp01 = (v) => Math.max(0, Math.min(1, v));
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);

    let ticking = false;
    let active = true;

    // Media query mobile
    const mqMobile = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;

    function getMoves() {
        const factor = mqMobile && mqMobile.matches ? MOBILE_FACTOR : 1;
        return {
            back: BASE_MOVE_BACK * factor,
            mid: BASE_MOVE_MID * factor
        };
    }

    function update() {
        ticking = false;
        if (!active) return;

        const { back: MOVE_BACK, mid: MOVE_MID } = getMoves();

        const scrollY = window.scrollY || window.pageYOffset || 0;
        const rect = hero.getBoundingClientRect();
        const heroTop = rect.top + scrollY;
        const heroH = hero.offsetHeight || rect.height || 1;

        const raw = clamp01((scrollY - heroTop) / heroH);
        const p = easeOut(raw);

        // verso l'alto (negativo)
        stack.style.setProperty('--par-back', `${(-p * MOVE_BACK).toFixed(2)}px`);
        stack.style.setProperty('--par-mid', `${(-p * MOVE_MID).toFixed(2)}px`);
    }

    function requestUpdate() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    // Attiva solo quando vicino al viewport
    if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
            (entries) => {
                active = entries.some((e) => e.isIntersecting);
                if (active) requestUpdate();
            },
            { threshold: 0, rootMargin: '200px 0px 200px 0px' }
        );
        io.observe(hero);
    }

    // Aggiorna quando cambia breakpoint mobile/desktop
    if (mqMobile && typeof mqMobile.addEventListener === 'function') {
        mqMobile.addEventListener('change', requestUpdate);
    } else if (mqMobile && typeof mqMobile.addListener === 'function') {
        // Safari / vecchi browser
        mqMobile.addListener(requestUpdate);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    requestUpdate();
}

function initImageStackTopParallax() {
    const stacks = document.querySelectorAll('.image-stack');
    if (!stacks.length) return;

    const prefersReduced =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    // Movimento base (desktop)
    const BASE_MOVE_TOP = 70; // px (aumenta/diminuisci)
    const MOBILE_FACTOR = 0.20;

    const clamp01 = (v) => Math.max(0, Math.min(1, v));
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);

    let ticking = false;

    const mqMobile = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;

    function getMoveTop() {
        const factor = mqMobile && mqMobile.matches ? MOBILE_FACTOR : 1;
        return BASE_MOVE_TOP * factor;
    }

    function update() {
        ticking = false;

        const MOVE_TOP = getMoveTop();
        const vh = window.innerHeight || document.documentElement.clientHeight;

        stacks.forEach((stack) => {
            const topEl = stack.querySelector('.image-stack__item--top');
            if (!topEl) return;

            const rect = stack.getBoundingClientRect();

            // progress 0..1 mentre lo stack attraversa il viewport
            const raw = clamp01((vh - rect.top) / (vh + rect.height));
            const p = easeOut(raw);

            // verso il basso (positivo). Per andare su: metti -p * MOVE_TOP
            const topY = -p * MOVE_TOP;

            topEl.style.setProperty('--par-top', `${topY.toFixed(2)}px`);
        });
    }

    function requestUpdate() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    // aggiorna al cambio breakpoint
    if (mqMobile && typeof mqMobile.addEventListener === 'function') {
        mqMobile.addEventListener('change', requestUpdate);
    } else if (mqMobile && typeof mqMobile.addListener === 'function') {
        mqMobile.addListener(requestUpdate);
    }

    requestUpdate();
}

// ========================================
// Feature Detection
// ========================================
document.documentElement.classList.add(
    'ontouchstart' in window ? 'touchevents' : 'no-touchevents'
);

if (!document.createElement('svg').getAttributeNS) {
    document.documentElement.classList.add('no-svg');
}


